module.exports = __webpack_public_path__ + "static/media/settings-hover.08f4e6b8.svg";